module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagnosis-card"
  }, [_c('span', {
    staticClass: "dev-annotation calculated"
  }, [_vm._v("Your Logic")]), _vm._v(" "), _c('div', {
    staticClass: "diagnosis-header"
  }, [_c('div', {
    staticClass: "diagnosis-title"
  }, [_c('div', {
    staticClass: "icon-wrap"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "11",
      "cy": "11",
      "r": "8"
    }
  }), _c('path', {
    attrs: {
      "d": "M21 21l-4.35-4.35"
    }
  })])]), _vm._v("\n      Diagnosis\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "live-badge"
  }, [_vm._v("Live Data")])]), _vm._v(" "), _c('div', {
    staticClass: "diagnosis-content"
  }, [_c('div', {
    staticClass: "diagnosis-headline"
  }, [_c('h3', [_vm._v(_vm._s(_vm.diagnosis.primaryCause))]), _vm._v(" "), _c('span', {
    staticClass: "confidence-badge"
  }, [_vm._v("• " + _vm._s(_vm.confidenceLabel))])]), _vm._v(" "), _c('p', {
    staticClass: "diagnosis-text"
  }, [_vm._v(_vm._s(_vm.diagnosis.description))])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dev-notes"
  }, [_c('div', {
    staticClass: "dev-notes-title"
  }, [_vm._v("Developer Notes — Diagnosis Logic")]), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("High Confidence:")]), _vm._v(" Price gap > 5% AND both FBA (or both FBM)")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Medium Confidence:")]), _vm._v(" Price gap < 5% OR mixed fulfillment")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Low Confidence:")]), _vm._v(" Price is competitive, non-price factor suspected")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fba8d426!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product-details/DiagnosisPanel.vue
// module id = 821
// module chunks = 2